import { UIState, UIErrorState, UISuccessState } from '../initial.state';
import { UIStateActionTypes } from '../actions';

const UIStateReducer = (state = new UIState(), action) => {
  switch (action.type) {
    case UIStateActionTypes.SHOW_MESSAGE:
      return {
        ...state,
        error: new UIErrorState(),
        success: new UISuccessState(),
        showSpinner: false,
        apiInProgress: false,
        [action.payload.variant]: {
          showBanner: action.payload.showBanner,
          message: action.payload.message,
          response: action.payload.response,
          alertAction: action.payload.alertAction,
          bannerAutoHideDuration: action.payload.bannerAutoHideDuration,
        },
        currentState: action.payload.variant,
      };

    case UIStateActionTypes.API_CALL_IN_PROGRESS:
      return {
        ...state,
        error: new UIErrorState(),
        success: new UISuccessState(),
        showSpinner: true,
        apiInProgress: true,
        currentState: 'inProgress',
      };

    case UIStateActionTypes.API_CALL_SUCCESS:
      return {
        ...state,
        error: new UIErrorState(),
        showSpinner: false,
        apiInProgress: false,
        success: {
          isSuccess: true,
          showBanner: action.payload.showBanner,
          message: action.payload.message,
          response: action.payload.response,
          alertAction: action.payload.alertAction,
          bannerAutoHideDuration: action.payload.bannerAutoHideDuration,
          isAuthTokenValid: true,
        },
        currentState: 'success',
      };

    case UIStateActionTypes.API_CALL_FAILED:
      return {
        ...state,
        success: new UISuccessState(),
        showSpinner: false,
        apiInProgress: false,
        error: {
          hasError: true,
          showBanner: true, // I am enforcing the UI to show the failure and reason
          message: action.payload.message,
          response: action.payload.response,
          alertAction: action.payload.alertAction,
          bannerAutoHideDuration: action.payload.bannerAutoHideDuration,
          isAuthTokenValid: action.payload.isAuthTokenValid,
        },
        currentState: 'error',
      };

    case UIStateActionTypes.UI_ROUTE_CHANGED:
      return {
        ...state,
        uiRouteState: [action.payload, ...state.uiRouteState],
      };

    case UIStateActionTypes.INVALID_PAGE_PERMISSION:
      return {
        ...state,
        success: new UISuccessState(),
        showSpinner: false,
        apiInProgress: false,
        error: {
          hasError: true,
          showBanner: true,
          message: action.payload.message,
          response: action.payload.response,
          alertAction: action.payload.alertAction,
          bannerAutoHideDuration: action.payload.bannerAutoHideDuration,
        },
        currentState: 'error',
      };

    case UIStateActionTypes.CRITICAL_DATA_ABSENT:
      return {
        ...state,
        success: new UISuccessState(),
        showSpinner: false,
        apiInProgress: false,
        error: {
          hasError: true,
          showBanner: true,
          message: action.payload.message,
          response: action.payload.response,
          alertAction: action.payload.alertAction,
          bannerAutoHideDuration: action.payload.bannerAutoHideDuration,
        },
        currentState: 'error',
      };

    case UIStateActionTypes.SHOW_SUCCESS_BANNER:
      return {
        ...state,
        error: new UIErrorState(),
        showSpinner: false,
        apiInProgress: false,
        success: {
          isSuccess: true,
          showBanner: action.payload.showBanner,
          message: action.payload.message,
          response: action.payload.response,
          alertAction: action.payload.alertAction,
          bannerAutoHideDuration: action.payload.bannerAutoHideDuration,
        },
        currentState: 'success',
      };

    case UIStateActionTypes.SHOW_ERROR_BANNER:
      return {
        ...state,
        success: new UISuccessState(),
        showSpinner: false,
        apiInProgress: false,
        error: {
          hasError: true,
          showBanner: true, // I am enforcing the UI to show the failure and reason
          message: action.payload.message,
          response: action.payload.response,
          alertAction: action.payload.alertAction,
          bannerAutoHideDuration: action.payload.bannerAutoHideDuration,
        },
        currentState: 'error',
      };

    case UIStateActionTypes.RESET_UI_STATE:
      return {
        ...state,
        error: new UIErrorState(),
      };

    default:
      return state;
  }
};

export { UIStateReducer };
